import { ApplicationDataBaseField } from './ApplicationDataBaseField';
import { Controller } from 'react-hook-form';
import { InputGroup } from '@blueprintjs/core';
import { ApplicationDataFormFieldPath } from '../ApplicationDataForm/ApplicationDataFormSchema';
import { ApplicationDataFieldCommonProps } from './types';

function defaultFormatter(value: unknown) {
  return value ? String(value) : '-';
}

interface ApplicationDataTextFieldProps
  extends ApplicationDataFieldCommonProps {
  name: ApplicationDataFormFieldPath;
  formatter?: (value: unknown) => string;
}

export const ApplicationDataTextField: React.FC<
  ApplicationDataTextFieldProps
> = ({ name, formatter = defaultFormatter, placeholder, ...props }) => (
  <Controller
    name={name}
    render={({ field, fieldState }) => (
      <ApplicationDataBaseField
        errorMessage={
          fieldState.invalid ? fieldState.error?.message : undefined
        }
        valueElement={formatter(field.value as never)}
        inputElement={
          <InputGroup
            type="text"
            name={field.name}
            onChange={field.onChange}
            onBlur={field.onBlur}
            value={field.value ?? ''}
            inputRef={field.ref}
            placeholder={placeholder}
            fill
          />
        }
        {...props}
      />
    )}
  />
);
